export const LAZY_LOAD_PAGE_SIZE = 50;
export const LAZY_LOAD_SCROLL_THRESHOLD = 100;
